import PropTypes from 'prop-types';
import { noCase } from 'change-case';
import { useState, useEffect } from 'react';
// @mui
import {
  Box,
  List,
  Badge,
  Button,
  Avatar,
  Tooltip,
  Divider,
  Typography,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
} from '@mui/material';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { PATH_DASHBOARD } from '../../../routes/paths';
// utils
import { fToNow } from '../../../utils/formatTime';
// _mock_
import { _notifications } from '../../../_mock';
// components
import Iconify from '../../../components/Iconify';
import DateFormat from 'src/components/DateFormat';
import Scrollbar from '../../../components/Scrollbar';
import MenuPopover from '../../../components/MenuPopover';
import { IconButtonAnimate } from '../../../components/animate';
import { getRecentNotification } from '../../../redux/slices/DashboardNotification';
import { useDispatch, useSelector } from '../../../redux/store';
// ----------------------------------------------------------------------

export default function NotificationsPopover() {

  const id = useParams();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState(_notifications);
  const [dashboardNotification, setDashboardNotification] = useState([]);
  const [notificationType, setnotificationType] = useState([]);


  const { notificationData } = useSelector((state => {
    return {

      // Accounthelp: state && state.settings && state.settings.AccountTalentHelp && state.settings.AccountTalentHelp.data && state.settings.AccountTalentHelp.data.response,
      // notificationData: state && state.DashBoardNotification && state.DashBoardNotification.DashboardNotificationSucc && state.DashBoardNotification.DashboardNotificationSucc.response,
      notificationData: state && state.DashboardNotification && state.DashboardNotification.DashboardNotificationSucc && state.DashboardNotification.DashboardNotificationSucc && state.DashboardNotification.DashboardNotificationSucc.response,



    }
  }))

  console.log(notificationData, 'notificationData244548')

  // const totalUnRead = notificationData.filter((item) => item.isUnRead === true).length;
  // const totalUnRead = dashboardNotification.length; 
  const totalUnRead = dashboardNotification.length > 0 ? dashboardNotification.length : "0";


  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleMarkAllAsRead = () => {
    setDashboardNotification(
      notificationData.map((notificationData) => ({
        ...notificationData,
        isUnRead: false,
      }))
    );
  };

  useEffect(() => {
    dispatch(getRecentNotification());
  }, [])

  // const handleIconClick = () => {
  //   dispatch(getRecentNotification());
  // };

  useEffect(() => {
    if (notificationData && notificationData.notifications && notificationData.notifications.length > 0) {
      setDashboardNotification(notificationData.notifications);
    }
  }, [notificationData]);

  const handleButtonClick = () => {
    // Navigate to the desired page
    navigate(PATH_DASHBOARD.inBox.notification, { replace: true });
  };


  console.log(dashboardNotification, '54dd6554')

  return (
    <>




      <IconButtonAnimate color={open ? 'primary' : 'default'} onClick={handleOpen} sx={{ width: 40, height: 40 }}>
        <Badge badgeContent={totalUnRead} color="error" >
          <Iconify icon="eva:bell-fill" width={20} height={20} />
        </Badge>
      </IconButtonAnimate>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{ width: 360, p: 0, mt: 1.5, ml: 0.75 }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1">Notifications</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              You have {totalUnRead}  messages
            </Typography>
          </Box>

          {totalUnRead > 0 && (
            <Tooltip title=" Mark all as read">
              <IconButtonAnimate color="primary" onClick={handleMarkAllAsRead}>
                <Iconify icon="eva:done-all-fill" width={20} height={20} />
              </IconButtonAnimate>
            </Tooltip>
          )}
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Scrollbar sx={{ maxheight: { xs: 440, sm: 400, md: 400 } }}>
          <List>
            {dashboardNotification.length === 0 ? (
              // Render a card or message when no data is found
              <Box sx={{ p: 2, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                  No notifications found.
                </Typography>
              </Box>
            ) : (
              // Render the list of notifications
              dashboardNotification.map((notification, index) => (
                <NotificationItem key={index} dashboardNotification={notification} />
              ))
            )}


          </List>


        </Scrollbar>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Box sx={{ p: 1 }}>
          <Button fullWidth disableRipple onClick={handleButtonClick}>
            View All
          </Button>
        </Box>
      </MenuPopover>
    </>
  );
}



function NotificationItem({ dashboardNotification }) {
  // const { avatar, title } = renderContent( dashboardNotification);
  // const { icon_image, job_title, message } = renderContent(dashboardNotification);
  // console.log(notification, '5548541')
  return (
    <ListItemButton
      sx={{
        py: 1.5,
        px: 2.5,

        borderBottom: "1px solid eee",
        mt: '1px',
        ...(dashboardNotification.isUnRead && {
          bgcolor: 'action.selected',
        }),
      }}
    >
      <ListItemAvatar>
        {/* <Avatar sx={{ bgcolor: 'background.neutral' }}>{dashboardNotification.icon_image}
        
        </Avatar> */}
        <Avatar src={dashboardNotification.icon_image} alt='NotificationIcon' />


        {
          console.log(dashboardNotification.icon_image, 'dfdsjlfdjsf')
        }
      </ListItemAvatar>
      {/* <ListItemText
        primary={dashboardNotification.message}
        
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled',
            }}
          >
            <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
            <DateFormat date={dashboardNotification.created_at} />
            
            {console.log(dashboardNotification.icon_image, 'fdferer')}
           
          </Typography>
        }
      /> */}

      <ListItemText
        primary={
          <Tooltip title={dashboardNotification.message} sx={{ cursor: "pointer" }}>
            <Typography
              variant="body1"
              className='firstLetter'
              fontSize={15}
              fontWeight={600}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '200px', // Set a specific max width
              }}
            >
              {dashboardNotification.message}
            </Typography>
          </Tooltip>
        }
        secondary={
          <Typography
            variant="caption"
            sx={{
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              color: 'text.disabled',
            }}
          >
            <Iconify icon="eva:clock-outline" sx={{ mr: 0.5, width: 16, height: 16 }} />
            <DateFormat date={dashboardNotification.created_at} />
          </Typography>
        }
      />


    </ListItemButton>
  );
}



